import { render, staticRenderFns } from "./number-field.vue?vue&type=template&id=20c87c4b&"
import script from "./number-field.vue?vue&type=script&lang=js&"
export * from "./number-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports